export const validateCode = (code: string): boolean => code.length >= 5;
